import { Modal, Button, Typography, Space, Card, Tag } from 'antd';
import { formatEndTime } from '../../utils/entity-utils';
import {ScopeMaintain, mapMantenanceScope, ServiceCodeMaintain} from '../../assets/constants/constants';

interface ServiceMaintain {
    serviceCode: ServiceCodeMaintain;
    providerNames?: string[];
}

interface ServiceMaintainEntity {
    serviceCode: ServiceCodeMaintain;
    dataPacks?: string[];
}

interface PartnerMaintain {
    cpCode: string;
    infoMaintain?: ServiceMaintainEntity[];
}

interface DataPackMaintainEntity {
    id: string;
    providerNames?: string[];
}

interface PackageMaintain {
    serviceCode: ServiceCodeMaintain;
    dataPacks?: DataPackMaintainEntity[];
}

interface CurrentScheduler {
    id: string;
    name: string;
    startTime: string;
    expireTime: number;
    note?: string;
    createdAt: string;
    createdBy: string;
    scopeType: ScopeMaintain;
    serviceMaintains?: ServiceMaintain[];
    partnerMaintains?: PartnerMaintain[];
    packageMaintains?: PackageMaintain[];

}

interface ModalViewCurrentSchedulersProps {
    open: boolean;
    onClose: () => void;
    currentSchedulers: CurrentScheduler[];
    onViewDetail: (scheduler: CurrentScheduler) => void;
    onDelete: (scheduler: CurrentScheduler) => void;
}

const ModalViewCurrentSchedulers: React.FC<ModalViewCurrentSchedulersProps> = ({
    open,
    onClose,
    currentSchedulers,
    onViewDetail,
    onDelete,
}) => {
    return (
        <Modal
            title="Lịch trình bảo trì đang hoạt động"
            open={open}
            onCancel={onClose}
            footer={[
                <Button key="close" onClick={onClose}>
                    Đóng
                </Button>
            ]}
            width={800}
        >
            <div style={{ marginBottom: 16 }}>
                <Typography.Text type="warning">
                    Có <strong>{currentSchedulers?.length || 0}</strong> lịch trình bảo trì đang hoạt động
                </Typography.Text>
            </div>
            <Space direction="vertical" style={{ width: '100%' }} size="middle">
                {currentSchedulers?.map((scheduler: any, index: number) => (
                    <Card
                        key={scheduler.id || index}
                        size="small"
                        style={{ backgroundColor: '#fff7e6', border: '1px solid #ffa940' }}
                        title={
                            <Space>
                                <Typography.Text strong>{scheduler.name}</Typography.Text>
                            </Space>
                        }
                        extra={
                            <Space>
                                <Button
                                    size="small"
                                    type="link"
                                    onClick={() => {
                                        onViewDetail(scheduler);
                                    }}
                                >
                                    Xem chi tiết
                                </Button>
                                <Button
                                    size="small"
                                    type="link"
                                    danger
                                    onClick={() => {
                                        onDelete(scheduler);
                                    }}
                                >
                                    Xóa
                                </Button>
                            </Space>
                        }
                    >
                        <Space direction="vertical" style={{ width: '100%' }} size="small">
                            <div>
                                <Typography.Text type="secondary">Phạm vi: </Typography.Text>
                                <Tag color="blue">
                                    {scheduler.scopeType ? mapMantenanceScope[scheduler.scopeType as ScopeMaintain] : '-'}
                                </Tag>
                            </div>
                            <div>
                                <Typography.Text type="secondary">Thời gian bắt đầu: </Typography.Text>
                                <Typography.Text strong>{scheduler.startTime}</Typography.Text>
                            </div>
                            <div>
                                <Typography.Text type="secondary">Thời gian kết thúc: </Typography.Text>
                                <Typography.Text strong>
                                    {scheduler.expireTime ? formatEndTime(scheduler.startTime, scheduler.expireTime) : 'Không giới hạn'}
                                </Typography.Text>
                            </div>
                            <div>
                                <Typography.Text type="secondary">Thời gian còn lại: </Typography.Text>
                                <Typography.Text strong>
                                    {((): string => {
                                        const startDate = new Date(scheduler.startTime);
                                        const endDate = new Date(startDate.getTime() + scheduler.expireTime * 1000);
                                        const now = new Date();
                                        const remainingMs = endDate.getTime() - now.getTime();

                                        if (remainingMs <= 0) {
                                            return 'Đã hết hạn';
                                        }

                                        const remainingSeconds = Math.floor(remainingMs / 1000);
                                        const hours = Math.floor(remainingSeconds / 3600);
                                        const minutes = Math.floor((remainingSeconds % 3600) / 60);
                                        const seconds = remainingSeconds % 60;

                                        if (hours > 0) {
                                            return `${hours} giờ ${minutes} phút`;
                                        } else if (minutes > 0) {
                                            return `${minutes} phút ${seconds} giây`;
                                        } else {
                                            return `${seconds} giây`;
                                        }
                                    })()}
                                </Typography.Text>
                            </div>
                            {scheduler.note && (
                                <div>
                                    <Typography.Text type="secondary">Ghi chú: </Typography.Text>
                                    <Typography.Text italic>{scheduler.note}</Typography.Text>
                                </div>
                            )}
                        </Space>
                    </Card>
                ))}
            </Space>
        </Modal>
    );
};

export default ModalViewCurrentSchedulers;
